import { render, staticRenderFns } from "./ContentItemsEditTabPermissions.vue?vue&type=template&id=419aa7df&"
import script from "./ContentItemsEditTabPermissions.vue?vue&type=script&lang=js&"
export * from "./ContentItemsEditTabPermissions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports